module.exports = __webpack_public_path__ + "static/media/fire_rings.7bd3a9f4.JPG";